import React from "react";

import Modal from "~/ui/Modal";

// TODO: add a proper error message and improve the UI
export default function TranscriptPreviewFailedModal({ closeModal }: { closeModal: () => void }) {
	return (
		<Modal onClose={closeModal} width="62.5rem">
			<Modal.Header onClose={closeModal}>
				<Modal.Title>Transcript Preview Failed</Modal.Title>
			</Modal.Header>
			<Modal.Body noPadding dark>
				Something went wrong. please try again.
			</Modal.Body>
			<Modal.Footer></Modal.Footer>
		</Modal>
	);
}
